
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/rEditor/rootComps/loaderOnStage/styles.scss.css.virtualfile';
        module.exports = {"panel":"_panel_ubc2l_7"};